import {RsnButton} from '@raison/ui-kit';
import {Atom, useAtomValue} from 'jotai';
import React from 'react';

type BrokerAccountRequestStatus = 'rejected' | 'none' | 'requested' | 'signed';

export interface BrokerAccountService {
    query: Atom<{data: BrokerAccountRequestStatus | undefined}>;
    request: Atom<{isPending: boolean; mutate: () => void}>;
}

export interface WithBrokerAccountService {
    brokerAccount: BrokerAccountService;
}

/**
 * this button is needed only for rare cases when a manager without access to CRM needs to tell
 * the client what to do to get a broker account and for ordinary clients it is not needed.
 * Therefore, if an ordinary user clicks on the button, he will be
 * refused manually and there will be no need to show the button anymore.
 */
export function BrokerAccountButton({query, request}: BrokerAccountService) {
    const {isPending, mutate} = useAtomValue(request);
    const {data: requestStatus} = useAtomValue(query);

    // this is a quick and shitty solution BY DESIGN 👌
    switch (requestStatus) {
        case 'none':
            return (
                <RsnButton.Secondary disabled={isPending} onClick={() => mutate()}>
                    Request broker account
                </RsnButton.Secondary>
            );
        case 'requested':
            return <RsnButton.Secondary disabled>Broker account requested</RsnButton.Secondary>;
        default:
            return null;
    }
}
